import type React from 'react';

import formatDistanceStrict from 'date-fns/formatDistanceStrict';
import ru from 'date-fns/locale/ru';
import parseISO from 'date-fns/parseISO';

import { useConsultation } from '@src/entities/consultations';

type Props = {
	id: number;
};

export const ConsultationDuration: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	return (
		<>
			{consultation &&
				formatDistanceStrict(parseISO(consultation.start_time), parseISO(consultation.end_time), {
					locale: ru,
				})}
		</>
	);
};
